export default __webpack_public_path__ + "static/media/ui_refresh-feed.6d4675ad.ogg";